import {combineReducers} from 'redux';
import tales from './tales';
import auth from './auth';
import groups from './groups';
import supportAssistant from './supportAssistant';
import resources from './resources';
import feedback from './feedback';

const appReducer = combineReducers({
    tales,
    auth,
    groups,
    supportAssistant,
    resources,
    feedback
});

const rootReducer = (state, action) => {
    if (action.type === 'LOGOUT') {
        // Clear all Redux state
        state = undefined;
    }
    return appReducer(state, action);
};

export default rootReducer;